import { FC } from "react";
import { StyleSheet, Text, TextProps, View, ViewProps } from "react-native";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";

export const PdBadge: FC<ViewProps> = ({ style, ...rest }) => {
  return <View style={[styles.pdBadge, style]} {...rest} />;
};

export const PdBadgeLabel: FC<TextProps> = ({ style, ...rest }) => {
  return <Text style={[styles.pdBadgeLabel, style]} numberOfLines={1} {...rest} />;
};

const styles = StyleSheet.create({
  pdBadge: {
    alignItems: "center",
    borderRadius: 5,
    flexDirection: "row",
    height: 18,
    paddingHorizontal: 6,
    paddingVertical: 1,
  },
  pdBadgeLabel: {
    ...kFonts.bodySmallCenter,
    color: kColors.brandDark,
    fontWeight: "500",
    textTransform: "uppercase",
  },
});
